import { LongTextField, Required, Schema, TextField } from "lego-gui-lib";
import { createContext } from "react";
import { t } from "../../../core/i18n/i18n";
import { CustomerMessagesFK } from "../schema";
import { LanguageFK } from "../../language/schema";
import { api, mainStore } from "../../../core/mainStore";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { UploadField } from "lego-gui-lib/lib/components/Inputs/Upload/UploadField";
import { DataDownloadMixin } from "./DataDownloadMixin";
import { Auth } from "../../../core/model/auth";

export const MediaTypes = [
  { label: t("hns:messageData:MediaType.sms"), value: "SMS" },
  { label: t("hns:messageData:MediaType.sub"), value: "VOICE" }
];

export const MessageDataSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  fields: [
    {
      name: "messageRef",
      type: CustomerMessagesFK,
      title: t("hns:messageRef")
    },
    {
      name: "languageRef",
      type: LanguageFK,
      title: t("common:language")
    },
    {
      name: "smsText",
      type: TextField(),
      title: t("hns:messageData:smsText")
    },
    {
      name: "file",
      type: UploadField(
        {
          accept: ["audio/wav", "audio/x-wav"]
        },
        Required
      ),
      title: t("common:file")
    }
  ]
});

export const SMSDataSchema = MessageDataSchema.extend({
  messageRef: false,
  file: false
});

export const SMSFormSchema = SMSDataSchema.extend({
  smsText: { type: LongTextField() }
});

export const AnnouncementFormSchema = MessageDataSchema.extend({
  messageRef: false,
  smsText: false
});

export const AnnouncementIndexSchema = MessageDataSchema.extend({
  messageRef: false,
  smsText: false,
  file: false
});

mainStore.messageData = RemoteChildDataSource.create({
  api: api,
  name: "messageData",
  schema: MessageDataSchema,
  url: "/data",
  commons: mainStore.commons,
  parent: mainStore.message.oneDataSource
});

export const messageDataContext = createContext(mainStore.messageData);

DataDownloadMixin(mainStore.messageData.listDataSource);
DataDownloadMixin(mainStore.messageData.oneDataSource);
